import dayjs from 'dayjs'
import advanced from 'dayjs/plugin/advancedFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import * as T from 'types'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advanced) // adds 'Z' timezone formatting support

/*
 * All times should be in EST/EDT and in mm/dd/yy, h:mm A Timezone format
 * except for showing and availability times which are listing location specific
 */
export const calculateTimeWithTimezone = (time: Date, listingTimezone: string, format: string) => {
  if (!time) return null

  const date = dayjs(time)
    .tz(listingTimezone || 'America/New_York')
    .format(format || 'h:mm A z')
  return date === 'Invalid Date' ? 'Invalid Date' : date
}

// return EST, EDT, PST, PDT...
export const getTimeZoneAbbreviation = (listing: T.IListing, time: Date) =>
  dayjs.tz(time, listing.timeZone || 'America/New_York').format('z')

export const updateDateWithTimezone = (value: Date, listingTimezone: string): Date => {
  const tz: string = dayjs.tz.guess()
  const currentOffset: number = dayjs.tz(dayjs(), tz).utcOffset()
  const listingOffset: number = dayjs.tz(value, listingTimezone).utcOffset()
  const timeInHours: number = (listingOffset - currentOffset) / 60
  return dayjs(value).subtract(timeInHours, 'hours').toDate()
}

export const applyTimeZone = (value: string, listingTimezone: string) => {
  if (!value) return undefined

  return dayjs(value).tz(listingTimezone).format()
}

export const isDST = (time: Date) => {
  const standardDayOffset = dayjs('01/05/2021').utcOffset()
  const dstDayOffset = dayjs('06/05/2021').utcOffset()
  const timeOffset = dayjs(time).utcOffset()

  if (timeOffset === dstDayOffset) return true

  if (timeOffset === standardDayOffset) return false

  // we shouldn't get here, so if we do, error log and return false as a default
  console.error('isDST: unexpected offset', dayjs(time).utcOffset())
  return false
}

export const addDSTOffset = (time: Date) => {
  if (isDST(new Date()) && !isDST(time)) return dayjs(time).subtract(1, 'hour').toDate()

  if (!isDST(new Date()) && isDST(time)) return dayjs(time).add(1, 'hour').toDate()

  return time
}
